import { useNavigate } from 'react-router-dom';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { removeFromCart } from '@/apis/main';
import useApi from './useApi';
import useLocalStorage from './useLocalStorage';
import * as amplitude from '@amplitude/analytics-browser';

export const useReset = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { fetchApi } = useApi();
  const [_, setLocalFormState] = useLocalStorage('local-form-state', {});

  const deleteCartMutation = useMutation({
    mutationFn: (offerList: number[]) => fetchApi((accessToken) => removeFromCart(offerList, accessToken))
  });

  const resetCart = () => {
    deleteCartMutation.mutate([]);
  };

  const goHome = () => {
    // 모든 진행 중인 쿼리 취소
    queryClient.cancelQueries();
    // 캐시된 쿼리 데이터 초기화
    queryClient.clear();
    // 장바구니 초기화
    resetCart();
    //입력값 초기화
    setLocalFormState({});
    //로그아웃
    amplitude.reset();
    amplitude.setSessionId(Date.now());
    // 홈으로 이동
    navigate('/');
  };

  return {
    resetCart,
    goHome
  };
};

export default useReset;
